import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

@Injectable()
export class MasterService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;
  
  changeOrder (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/change_order',param,this.Options)
    .pipe(
      tap(Response => this.commonService.loadingEnd()),
      catchError(this.commonService.handleError('contractcompany_list', []))
    );
  }
  /* 契約会社マスタメンテナンス関連 */
  getContractCompany (mode:number){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/contractcompany/contract_company_list/'+ mode,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('contractcompany_list', []))
      );
  }
  saveContractCompany (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/contractcompany/save',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('contractcompany_list', []))
      );
  }
  deleteContractCompany (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/contractcompany/delete',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('contractcompany_list', []))
      );
  }
  setContractCompany (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/contractcompany/set',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('contractcompany_list', []))
      );
  }

  // //言語マスタ
  getLanguage (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/language/language_list_all/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('language_list', []))
      );
  }
  saveLanguage (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/language/save_language',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateLanguage (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/language/update_language',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteLanguage (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/language/delete_language',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderLanguage (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/language/language_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //マスタメンテナンスで使用
  getEvent (eid:number){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/event_maintenance/'+eid,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  //会社マスタ
  getCompany (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/company/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getCompanyList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/company/search_list/'+ param.eid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('jigyoba_list', []))
      );
  }
  saveCompany (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/company/save_company',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateCompany (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/company/update_company',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteCompany (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/company/delete_company',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderCompany (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/company/company_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
   //  //区分１マスタ
  getDivision_1 (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/ydivision1/division1_list/' + param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('question_list', []))
      );
  }
  getDivision_1List (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    if(param.point==""|| param.point==null){param.point = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/course/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name+ '/' + param.point,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('course_list', []))
      );
  }
  
  saveDivision_1 (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/course/save_course',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateDivision_1(param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/course/update_course',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteDivision_1 (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/course/delete_course',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderDivision_1 (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/course/course_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //  //コースマスタ
   getCourse (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/course/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }

  getCourseList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    if(param.point==""|| param.point==null){param.point = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/course/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name+ '/' + param.point,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('course_list', []))
      );
  }
  
  saveCourse (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/course/save_course',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateCourse(param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/course/update_course',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteCourse (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/course/delete_course',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderCourse (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/course/course_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //事業場マスタ
  getJigyoba (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/jigyoba/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getJigyobaList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/jigyoba/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('jigyoba_list', []))
      );
  }
  saveJigyoba (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/jigyoba/save_jigyoba',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateJigyoba (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/jigyoba/update_jigyoba',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteJigyoba (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/jigyoba/delete_jigyoba',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderJigyoba (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/jigyoba/jigyoba_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //職場マスタ
  getSyokuba (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/syokuba/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getSyokubaList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/syokuba/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('syokuba_list', []))
      );
  }
  saveSyokuba (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syokuba/save_syokuba',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateSyokuba (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syokuba/update_syokuba',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteSyokuba (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syokuba/delete_syokuba',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderSyokuba (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syokuba/syokuba_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //所属マスタ
  getSyozoku (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/syozoku/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getSyozokuList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/syozoku/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('syozoku_list', []))
      );
  }
  saveSyozoku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syozoku/save_syozoku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateSyozoku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syozoku/update_syozoku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteSyozoku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syozoku/delete_syozoku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderSyozoku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syozoku/syozoku_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //事業所マスタ
  getJigyosyo (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/jigyosyo/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getJigyosyoList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/jigyosyo/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('jigyosyo_list', []))
      );
  }
  saveJigyosyo (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/jigyosyo/save_jigyosyo',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateJigyosyo (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/jigyosyo/update_jigyosyo',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteJigyosyo (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/jigyosyo/delete_jigyosyo',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderJigyosyo (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/jigyosyo/jigyosyo_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
　//役職マスタ
  getYakusyoku (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/yakusyoku/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getYakusyokuList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/yakusyoku/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('yakusyoku_list', []))
      );
  }
  saveYakusyoku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/yakusyoku/save_yakusyoku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateYakusyoku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/yakusyoku/update_yakusyoku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteYakusyoku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/yakusyoku/delete_yakusyoku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderYakusyoku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/yakusyoku/yakusyoku_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //資格マスタ
  getShikaku (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/shikaku/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getShikakuList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/shikaku/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('shikaku_list', []))
      );
  }
  saveShikaku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/shikaku/save_shikaku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateShikaku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/shikaku/update_shikaku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteShikaku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/shikaku/delete_shikaku',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderShikaku (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/shikaku/shikaku_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //職種マスタ
  getSyokusyu (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/syokusyu/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getSyokusyuList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/syokusyu/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('syokusyu_list', []))
      );
  }
  saveSyokusyu (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syokusyu/save_syokusyu',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateSyokusyu (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syokusyu/update_syokusyu',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteSyokusyu (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syokusyu/delete_syokusyu',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderSyokusyu (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/syokusyu/syokusyu_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
  //身分マスタ
  getMibun (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/mibun/company_list/'+param.eid + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('company_list', []))
      );
  }
  getMibunList (param:any){
    if(param.code=="" || param.code==null){param.code = null};
    if(param.name=="" || param.name==null){param.name = null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/master/mibun/search_list/'+ param.cid + '/'+ param.page + '/'  + param.display_per_page + '/' + param.code +'/'+ param.name,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('mibun_list', []))
      );
  }
  saveMibun (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/mibun/save_mibun',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveLanguage', []))
      );
  }
  updateMibun (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/mibun/update_mibun',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateLanguage', []))
      );
  }
  deleteMibun (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/mibun/delete_mibun',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteLanguage', []))
      );
  }
  changeOrderMibun (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/master/mibun/mibun_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateL', []))
      );
  }
}


// WEBPACK FOOTER //
// ./src/app/service/master.service.ts